import { useEffect } from 'react';
import { SubmitHandler, useForm, UseFormReturn } from 'react-hook-form';

import { useNavigate } from '@/hooks/useNavigate';
import { FormValues } from '@/types';

interface Props {
  value: FormValues['categories'];
  onChange: (categories: FormValues['categories']) => void;
  onClose: () => void;
  onCloseCategory?: () => void;
  externalMethods?: UseFormReturn<Pick<FormValues, 'categories'>>;
}

const id = 'categoryModalFormId';

export const useCategoryModal = ({
  externalMethods,
  value,
  onChange,
  onClose,
  onCloseCategory
}: Props) => {
  const internalMethods = useForm<{ categories: FormValues['categories'] }>({
    defaultValues: { categories: value }
  });

  const methods = externalMethods ?? internalMethods;
  const { setParams } = useNavigate();

  useEffect(() => {
    methods.setValue('categories', value);
  }, [value]);

  const handleConfirm: SubmitHandler<{
    categories: FormValues['categories'];
  }> = ({ categories }) => {
    onChange(categories);
    onClose();
    setParams({
      categoryIds: categories.map(item => item.id)
    });
  };

  const handleReset = () => {
    onChange([]);
  };

  const handleClose = () => {
    onClose();
    onCloseCategory?.();
  };

  return {
    methods,
    handleConfirm,
    handleReset,
    handleClose,
    id
  };
};
